'use client'

import { useMemo } from 'react'

import { ButtonImage } from '@/components/common/Button'
import { CardLink, CardRec } from '@/components/common/Card'
import { useBreakpoints } from '@/components/providers/BreakpointProvider'
import { usePage } from '@/components/providers/PageProvider'
import { DATEFORMAT_FULL } from '@/defs/date'
import { useCardMap } from '@/hooks/useCardMap'
import { isNonEmptyString } from '@/utils/commonUtil'
import { formatDate } from '@/utils/formatUtil'

import styles from './HomeTopSidebar.module.scss'

export const HomeTopSidebar = () => {
  const { page } = usePage()
  const { commanderRec, date, trendingRecs, weeklyRecs } = page?.home || {}
  const cardIds = useMemo(
    () =>
      [
        commanderRec?.cardId,
        ...(trendingRecs?.map((r) => r.cardId) || []),
        ...(weeklyRecs?.map((r) => r.cardId) || []),
      ].filter(isNonEmptyString),
    [commanderRec, trendingRecs, weeklyRecs],
  )
  const { cardMap } = useCardMap({ cardIds })
  const { isDesktop } = useBreakpoints()

  return (
    <div className={styles.container}>
      {commanderRec && (
        <div className={styles.dailyCommander}>
          <h2 className={styles.heading}>
            <span className={styles.headingKicker}>{formatDate(date || '', DATEFORMAT_FULL)}</span>
            <span className={styles.headingTitle}>Commander of the Day</span>
          </h2>
          <div className={styles.cardWrap}>
            <CardRec extend forceLoad rec={commanderRec} />
          </div>
        </div>
      )}
      {!!weeklyRecs?.length && (
        <div className={styles.top}>
          <h2 className={styles.heading}>
            <span className={styles.headingKicker}>This Week</span>
            <span className={styles.headingTitle}>Top Commanders</span>
          </h2>
          <ul className={styles.list}>
            {weeklyRecs.slice(0, 10).map((rec, i) => (
              <li key={i}>
                <CardLink disableModal={isDesktop} placement='left' rec={rec}>
                  <ButtonImage
                    as='div'
                    borderNone
                    colorId={cardMap[rec.cardId]?.colorId || 'colorless'}
                    image={cardMap[rec.cardId]?.imageArt}
                    label={cardMap[rec.cardId]?.name}
                    nowrap
                    size='sm'
                  >
                    <strong>{`#${i + 1}.`}</strong> <span>{rec.name}</span>
                  </ButtonImage>
                </CardLink>
              </li>
            ))}
          </ul>
        </div>
      )}
      {!!trendingRecs?.length && (
        <div className={styles.trending}>
          <h3 className={styles.heading}>
            <span className={styles.headingKicker}>This Week</span>
            <span className={styles.headingTitle}>Trending Cards</span>
          </h3>
          <ul className={styles.list}>
            {trendingRecs.slice(0, 10).map((rec, i) => (
              <li key={i}>
                <CardLink disableModal={isDesktop} placement='left' rec={rec}>
                  <ButtonImage
                    as='div'
                    borderNone
                    colorId={cardMap[rec.cardId]?.colorId || 'colorless'}
                    image={cardMap[rec.cardId]?.imageArt}
                    label={cardMap[rec.cardId]?.name}
                    nowrap
                    size='sm'
                  >
                    <strong>{`#${i + 1}.`}</strong> <span>{rec.name}</span>
                  </ButtonImage>
                </CardLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
